/**
 * Groups the schema's eleven node types (docs/plans/06) into a handful of
 * visual categories, purely for scanning a graph faster — this has no
 * effect on validation, execution or what the Inspector shows. Reuses the
 * app's own semantic colors where one already fits (start/hangup/amd_gate)
 * rather than inventing a parallel palette for those three.
 */
export interface NodeTypeStyle {
  color: string;
  category: string;
}

const STYLES: Record<string, NodeTypeStyle> = {
  start: { color: "var(--ok)", category: "Flow control" },
  hangup: { color: "var(--fail)", category: "Flow control" },
  branch: { color: "var(--node-logic)", category: "Flow control" },
  repeat: { color: "var(--node-logic)", category: "Flow control" },
  play: { color: "var(--brand)", category: "Messaging" },
  tts: { color: "var(--brand)", category: "Messaging" },
  gather: { color: "var(--node-input)", category: "Input" },
  amd_gate: { color: "var(--warn)", category: "Input" },
  consent: { color: "var(--node-compliance)", category: "Compliance" },
  tag: { color: "var(--node-data)", category: "Data" },
  http: { color: "var(--node-integration)", category: "Integration" },
  transfer: { color: "var(--node-integration)", category: "Integration" },
};

const FALLBACK: NodeTypeStyle = { color: "var(--subtle)", category: "Other" };

export function nodeTypeStyle(type: string): NodeTypeStyle {
  return STYLES[type] ?? FALLBACK;
}
